import { FormulaStatics, ValueAndType } from "../basic/formulaEditor.model";
import { ValueType } from "../enums/valuetype.enum";
import { FormulaNodeCalculator } from "./formula.node.calculator";
import { RangeEnabledFormula } from "./iformula";

export class Min extends RangeEnabledFormula {
    static StaticID: string = '0febaad5-668f-4cd3-84d5-077f0c16b862';

    constructor() {
        super();
        this._ID = Min.StaticID;
        this._Name = 'Min';
        this._MaxVariableCount = FormulaStatics.IntMaxValue;
    }

    CanCalcNulls(): boolean {
        return true;
    }

    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        var retVal = new ValueAndType();
        retVal.Type = maxType;
        if (args && (maxType == ValueType.Long || maxType == ValueType.Double)) {
            var that = this;
            args.forEach(function (item) {
                if (typeof item.Value !== 'undefined' && item.Value != null) {
                    if (item.Type == ValueType.Range) {
                        that.HandleNumericRange(item, (val) => {
                            if (val != null && !isNaN(val)) {
                                if (retVal.Value == null || val < retVal.Value) {
                                    retVal.Value = val;
                                }
                            }
                        });
                    } else {
                        var val = Number(item.Value);
                        if (!isNaN(val)) {
                            if (retVal.Value == null || val < retVal.Value) {
                                retVal.Value = val;
                            }
                        }
                    }
                }
            });
        }
        return retVal;
    }
}